const registerApiQuery = `
mutation addCustomer($args_createCustomer: AddCustomerInput) {
  addCustomer(input: $args_createCustomer) {
    __typename
    ... on SuccessResponse {
      status
      message
    }
    ... on ErrorResponse {
      correlationId
      errorCode
      issues {
        field
        issue
      }
      legacyError
      message
      name
      priority
    }
    ... on CaptchaResponse {
      error {
        errorCode
        message
      }
      captcha {
        image
        sound
        clearScreen
        answer
      }
    }
    ... on SignInResponse {
      access_token
      token_type
      refresh_token
      scope
      id_token
      expires_in
      session_token
      pcp_number
    }
    ... on SignInOtpResponse {
      profile {
        transactionCount
      }
      tokenResponse {
        access_token
        id_token
        factor {
          factorStatus
          factorType
          factorValue
        }
        error {
          errorCode
          errorMessage
        }
      }
    }
    ... on OtpResponse {
      captcha {
        answer
        clearScreen
        image
        sound
      }
      error {
        err: errorCode
        priority
        errorName
        errorMessage
        correlationI
        legacyError
        details {
          code
          message
          primary
          source
        }
        suggestedActions
        type
        httpStatus
        errorType
      }
      msg: message
      status
      factor {
        id
        factorType
        factorValue
        factorStatus
      }
    }
  }
}`
const signInQuery = `
query  signIn( $signInReq:SignInInput, ) { signIn(input: $signInReq) {
__typename
... on SignInResponse {
profile {
  ap
  subscription {
    campaignName
    endDate
    subscriptionId
  }
  transactionCount
}
token {
  accessToken
  refreshToken
  expiresIn
  idToken
  prepaidToken
}
}
... on RedirectionResponse {
country
error {
  correlationId
  errorCode
  issues {
    field
    issue
  }
  legacyError
  message
  name
  priority
}
token {
  access_token
  expires_in
  id_token
  pcp_number
  refresh_token
  scope
  session_token
  subscription {
      campaignName
      endDate
      subscriptionId
  }
  token_type
  transactionCount

  profile {
    ap
    subscription {
      campaignName
      endDate
      subscriptionId
    }
    transactionCount
  }
  token {
    accessToken
    refreshToken
    expiresIn
    idToken
    prepaidToken
  }
}
}

... on ErrorResponse {
correlationId
errorCode
issues {
field
issue            
}
legacyError
message
name
priority
}
... on CaptchaResponse {
error {
  errorCode
  message
}
captcha {
  image
  sound
  clearScreen
  answer
}
}
} }`